import i18n from "i18next";
import { errorTextHelper } from "./ErrorHelper";

const ErrorHandler = (error) => {
  if (error?.errorCode) {
    const errorText = errorTextHelper(error);
    const multiLangText = errorText?.[i18n.language] || errorText;

    window.alert(multiLangText);
    return;
  }

  const errMsg =
    error?.error?.message ||
    error?.error?.msg ||
    error?.message ||
    error?.msg ||
    "Unknown Error. Please try again.";
  if (["cancelled", "已取消", "Failed to fetch"].indexOf(errMsg) === -1)
    window.alert(errMsg);
  console.log(error);
};

export const UncaughtRejectionHandler = (event) => {
  ErrorHandler(event.reason);
};

export default ErrorHandler;
